import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, reducedMotionVariants, reducedStaggerContainer } from './AnimationVariants';
import { useReducedMotion } from '@/hooks/use-reduced-motion';

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  stagger?: boolean;
  delay?: number;
}

export function AnimatedSection({ 
  children, 
  className = '',
  stagger = false,
  delay = 0
}: AnimatedSectionProps) {
  const prefersReducedMotion = useReducedMotion();
  
  const variants = prefersReducedMotion 
    ? (stagger ? reducedStaggerContainer : reducedMotionVariants)
    : (stagger ? staggerContainer : fadeInUp);

  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={variants}
      transition={prefersReducedMotion ? { duration: 0.01 } : { delay }}
    >
      {children}
    </motion.div>
  );
}

interface AnimatedItemProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export function AnimatedItem({ children, className = '', delay = 0 }: AnimatedItemProps) {
  const prefersReducedMotion = useReducedMotion();
  
  return (
    <motion.div
      className={className}
      variants={prefersReducedMotion ? reducedMotionVariants : fadeInUp}
      transition={prefersReducedMotion ? { duration: 0.01 } : { delay }}
    >
      {children}
    </motion.div>
  );
}

export { AnimatedSection as default };
